/**
 * Einheitliche Ampel-Logik für Weclapp-Ticketstatus: der Lebenszyklus läuft
 * farblich von Rot (liegt unangefasst) über Orange/Gelb (in Arbeit) nach
 * Grün (fertig). So ist auf jeder Liste sofort sichtbar, wo ein Ticket steht.
 *
 * Statusnamen sind in Weclapp frei konfigurierbar — gematcht wird case-insensitiv
 * über Namensmuster, mit dem Weclapp-Systemstatus als Fallback für unbekannte
 * Namen. Terminal ohne Erfolg (Duplikat, keine Lösung, zu löschen) ist bewusst
 * Grau: „aus dem Spiel", nicht „erledigt".
 */

const NAME_PATTERNS: Array<[RegExp, string]> = [
  // terminal ohne Erfolg — vor den anderen prüfen („keine lösung" enthält „lösung")
  [/keine\s*lösung|duplikat|zu\s*löschen|spam|storniert|abgelehnt/, 'gray'],
  // WIRKLICH fertig ist nur Geschlossen — Grün bleibt dem Ende vorbehalten,
  // sonst liest sich die halbe Liste als „positiv erledigt".
  [/geschlossen|closed|erledigt/, 'green'],
  [/zu\s*schließen|gelöst|fixed|resolved/, 'teal'],
  // vom Kunden bestätigt, aber noch nicht durch
  [/bestätigt|confirmed/, 'cyan'],
  // pausiert / wartet auf Rückmeldung — kein Fortschritt, deshalb neutral Blau
  [/wartend|warten|wieder\s*vorlage|pausiert/, 'blue'],
  // aktiv in Arbeit
  [/in\s*bearbeitung|bearbeitung|progress/, 'yellow'],
  // liegt unangefasst — VOR der Orange-Regel: „noch nicht zugewiesen" enthält
  // „zugewiesen" und würde sonst fälschlich Orange treffen
  [/noch\s*nicht|nicht\s*zugewiesen|unassigned|pool|neu|erstellt|offen|open|new/, 'red'],
  // angenommen, aber noch nichts passiert
  [/zugewiesen|angenommen|assigned/, 'orange'],
];

const SYSTEM_STATUS_COLORS: Record<string, string> = {
  UNASSIGNED: 'red',
  POOL: 'red',
  IN_PROGRESS: 'yellow',
  WAITING: 'blue',
  FIXED: 'teal',
  CLOSED: 'green',
};

/** Mantine-Farbname für einen Weclapp-Status (Name + optionaler Systemstatus). */
export function weclappStatusColor(name?: string | null, systemStatus?: string | null): string {
  const n = (name ?? '').toLowerCase();
  if (n) {
    for (const [pattern, color] of NAME_PATTERNS) {
      if (pattern.test(n)) return color;
    }
  }
  const sys = (systemStatus ?? '').toUpperCase();
  // Unbekannte Status neutral Indigo — Blau ist jetzt „Wartend" und wäre irreführend.
  return SYSTEM_STATUS_COLORS[sys] ?? 'indigo';
}

/** CSS-Variable der Statusfarbe — für Stellen ohne Mantine-Badge (z. B. CSS-Module-Spans). */
export function weclappStatusColorVar(name?: string | null, systemStatus?: string | null, shade = 5): string {
  return `var(--mantine-color-${weclappStatusColor(name, systemStatus)}-${shade})`;
}
